import React, { FC, useEffect, useMemo, useRef, useState } from 'react'
import {
  debounce,
  fetchData,
  formatNumber,
  getEncryptedRoute,
  getTranslatedValue,
  toasterrormsg,
  useMenuIdPermissions,
} from '../../../reusable'
import { KTIcon, toAbsoluteUrl } from '../../../_metronic/helpers'
import { ToastContainer } from 'react-toastify'
import DataTable from 'react-data-table-component'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Select, { CSSObjectWithLabel } from 'react-select'
import moment from 'moment'
import Loader from '../components/Loader'
import { Tr } from '../../../_metronic/i18n/Tr'
import { useLang } from '../../../_metronic/i18n/Metronici18n'

export interface PropertyList {
  value: string | number
  en_name: string | number
  uz_name: string | number
  ru_name: string | number
  label: string
}


const ViewHotelBooking: FC = () => {
  let t = Tr()
  const { menuIdEdit, menuId } = useMenuIdPermissions()
  const [hotelList, setHotelList] = useState([])
  const [inputValue, setInputValue] = useState('')
  const [searchTerm, setSearchTerm] = useState('')
  const [totalRecords, setTotalRecords] = useState(0)
  const [limit, setLimit] = useState(10)
  const [offset, setOffset] = useState(0)
  const [sortField, setSortField] = useState('')
  const [sortOrder, setSortOrder] = useState('')
  const [isDataLoaded, setIsDataLoaded] = useState(false)
  const [listFilters, setListFilters] = useState<any>({ categoryId: 1 })
  const [focus, setFocus] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [status, setStatus] = useState() as any
  const lang = useLang()
  const [fromDate, setFromDate] = useState('')
  const [toDate, setToDate] = useState('')

  const [selectedStatus, setSelectedStatus] = useState('') as any

  const [selectedProperty, setSelectedProperty] = useState('') as any

  const [selectedRoomType, setSelectedRoomType] = useState('') as any

  const [roomTypeList, setRoomTypeList] = useState([])

  const [statusList] = useState([
    { value: '0', label: 'Pending' },
    { value: '1', label: 'Approved' },
    { value: '2', label: 'Rejected' },
    { value: '3', label: 'Cancelled' },
    { value: '4', label: 'Completed' },
  ])

  const [propertyList, setPropertyList] = useState<{ value: string | number; label: string | number }[]>([]);

  const clearFields = () => {
    setFromDate('')
    setToDate('')
    setSelectedProperty(null)
    setSelectedStatus(null)
    setSelectedRoomType(null)
    BookingListApiCall('ALL', 1)
  }

  // Custom CSS to remove unnecessary scrollbar
  const customStyles: any = {
    tableWrapper: {
      style: {
        maxHeight: 'none', // Remove fixed height to allow dynamic growth
        overflowY: 'auto', // Only show scrollbar when content overflows
      },
    },
    rows: {
      style: {
        minHeight: 'auto', // Allow rows to size based on content
        padding: '4px 0', // Reduce padding to minimize row height
      },
    },
    cells: {
      style: {
        padding: '4px', // Reduce cell padding
        display: 'flex',
        alignItems: 'flex-start', // Align content to top
      },
    },
  }

  const propertyListApiCall = async () => {
    let param: any = {
      categoryId: '1',
    }

    var response: any = await fetchData('admin/propertylist', param)

    if (response.status == '200') {
      let data = response.data

      let opt: { value: number | string; label: string | number }[] = [];
      data.map((val: PropertyList) => {
        opt.push({ value: val.value, label: getTranslatedValue(lang, val, "_name") })
      })

      setPropertyList(opt)
    } else {
      toasterrormsg(response.message)
    }
  }

  // date formatr change function
  const formatDate = (date: string): string => {
    const [year, month, day] = date.split('-')
    return `${day}/${month}/${year}`
  }

  const formatDate2 = (date: any) => {
    return moment(date).format('DD-MM-YYYY')
  }

  // applies tab / filter params; the effect below fetches with pagination, sort and search
  const BookingListApiCall = (status: any, isClear?: any) => {
    if (fromDate && toDate && new Date(toDate) < new Date(fromDate)) {
      toasterrormsg('To Date Cannot Be Smaller Than From Date.')
      return
    }

    var param: any = {}

    if (status == 'ALL' && isClear == 1) {
      param = {
        categoryId: 1,
      }
    } else if (status == 'ALL' && isClear != 1) {
      param = {
        categoryId: 1,
        fromDate: fromDate != '' ? String(formatDate(fromDate)) : '',
        toDate: toDate != '' ? String(formatDate(toDate)) : '',
        propertyId: selectedProperty ? selectedProperty.value : '',
        roomtypeId: selectedRoomType ? selectedRoomType.value : '',
      }
    } else {
      param = {
        status: status,
        categoryId: 1,
        fromDate: fromDate != '' ? String(formatDate(fromDate)) : '',
        toDate: toDate != '' ? String(formatDate(toDate)) : '',
        propertyId: selectedProperty ? selectedProperty.value : '',
        roomtypeId: selectedRoomType ? selectedRoomType.value : '',
      }
    }
    setListFilters(param)
    setOffset(0)
  }

  //   hotel list api call
  const fetchBookingList = async () => {
    try {
      setIsLoading(true)
      const param = {
        ...listFilters,
        limit: limit,
        offset: offset,
        term: searchTerm.trim(),
        sortBy: sortField,
        sort: sortOrder,
      }
      const res = await fetchData('admin/bookinglist', param)

      if (res.status == '200') {
        console.log(res.data);
        
        setHotelList(Array.isArray(res.data) ? res.data : [])
        setTotalRecords(Number(res.totalRecords) || 0)
      } else {
        setHotelList([])
        setTotalRecords(0)
      }
    } catch (error) {
      console.error('Error fetching booking list:', error)
      toasterrormsg('Failed to fetch bookings')
      setHotelList([])
      setTotalRecords(0)
    } finally {
      setIsDataLoaded(true)
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchBookingList()
  }, [listFilters, limit, offset, sortField, sortOrder, searchTerm])

  // room type list api call

  const hotelRoomTypeListAPIcall = async () => {
    var res = await fetchData('vendor/public/hotelRoomTypeList', [])

    if (res.status == '200') {
      var opt: any = []
      res.data.map((val: any) => {
        opt.push({ value: val.roomtypeId, label: getTranslatedValue(lang, val, '_name', val.primaryLanguage) })
      })
      setRoomTypeList(opt)
    } else {
      toasterrormsg(res.message)
    }
  }

  const rejectconfirmation = async (status: any, id: any, bookingDetailId?: any) => {
    let swalOptions: any

    if (status == '2') {
      swalOptions = {
        title: t('Are You Sure? You Want to Reject This Booking.'),
        icon: 'warning',
        showCancelButton: true,
        input: 'text',
        inputLabel: 'Reason',
        inputPlaceholder: t('Enter Reject Reason'),
        inputValidator: (value: any) => {
          if (!value) {
            return t('Reject Reason Required!')
          }
        },
      }
    } else if (status == '1') {
      swalOptions = {
        title: t('Are You Sure? You Want to Approve This Booking.'),
        icon: 'warning',
        showCancelButton: true,
      }
    } else if (status == '3') {
      swalOptions = {
        title: t('Are You Sure? You Want to Cancel This Booking.'),
        icon: 'warning',
        showCancelButton: true,
        input: 'text',
        inputLabel: 'Reason',
        inputPlaceholder: t('Enter Cancel Reason'),
        inputValidator: (value: any) => {
          if (!value) {
            return t('Cancel Reason Required!')
          }
        },
      }
    }

    Swal.fire(swalOptions).then(async (result) => {
      if (result.isConfirmed) {
        var tmp2 = sessionStorage.getItem('admin')
        // Step 2: Check if the item is not null
        if (tmp2) {
          // Step 3: Parse the JSON string
          var adminData = JSON.parse(tmp2)
          // Step 4: Access the adminId
          var adminId = adminData.adminId
        }
        const inputValue = result.value

        if (
          status == '1' ||
          (status == '2' && inputValue !== undefined && inputValue.trim() !== '') ||
          (status == '3' && inputValue !== undefined && inputValue.trim() !== '')
        ) {
          var dataObj: any = {
            bookingId: id,
            status: status,
            adminId: adminId,
          }

          if (status == '2') {
            dataObj.reason = inputValue
          }

          if (status == '3') {
            dataObj.reason = inputValue
          }

          if (status == 3) {
            dataObj.bookingdetailId = bookingDetailId
            dataObj.cancellationDate = moment().format('YYYY-MM-DD HH:mm:ss.SSZZ')
            var res = await fetchData('admin/cancelbooking', dataObj)
          } else if (status == 2) {
            dataObj.categoryId = 1
            // var res2 = await fetchData('admin/rejectbooking', dataObj)
            var res = await fetchData('admin/approverejectbooking', dataObj)
          } else {
            dataObj.categoryId = 1
            var res = await fetchData('admin/approverejectbooking', dataObj)
          }

          if (res.status == 200) {
            Swal.fire({
              title: t('Status Change Successfully!'),
              icon: 'success',
            }).then((res) => {
              if (res.isConfirmed) {
                setStatus('')
                BookingListApiCall('ALL', 0)
              }
            })
          } else {
            toasterrormsg(res.message)
          }

          // if (status == 2) {
          //   if (res2.status == 200) {
          //     Swal.fire({
          //       title: t('Status Change Successfully!'),
          //       icon: 'success',
          //     }).then((res) => {
          //       if (res.isConfirmed) {
          //         setStatus('')
          //         BookingListApiCall('ALL', 0)
          //       }
          //     })
          //   } else {
          //     toasterrormsg(res2.message)
          //   }
          // }
        } else {
          Swal.fire({
            title: t('Invalid Input!'),
            text: t('Please enter a valid reason.'),
            icon: 'error',
          })
        }
      }
    })
  }
  // search hotel
  const hotelsearch = (text: any, isfoc: any) => {
    setInputValue(text)
    setFocus(isfoc)
    debouncedSearch(text)
  }

  const debouncedSearch = useRef(
    debounce((value: string) => {
      setSearchTerm(value)
      setOffset(0)
    }, 500)
  ).current

  useEffect(() => {
    return () => debouncedSearch.cancel()
  }, [])

  const handleSort = (column: any, sortDirection: string) => {
    setSortField(column.sortField || '')
    setSortOrder(sortDirection === 'asc' ? 'asc' : 'desc')
  }

  const handlePageChange = (newPage: number) => {
    setOffset((newPage - 1) * limit)
  }

  const handleRowsPerPageChange = (newRowsPerPage: number) => {
    setLimit(newRowsPerPage)
    setOffset(0)
  }

  const CustomHeader = (props: any) => {
    const inputRef: any = useRef(null)

    // Define the onchange event handler
    const handleChange = async (e: any) => {
      // Focus on the input element when the onchange event is triggered
      await props.customSearch(e, 1)
    }
    useEffect(() => {
      // Check if the ref exists and if the component should be focused
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus()
      }
    }, [props.isfoc])

    return (
      <div className=' d-flex justify-content-between w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 '>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={t('Search Booking')}
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>
      </div>
    )
  }
  const column = useMemo(
    () => [
      {
        name: t('Booking Id'),
        cell: (row: any) => (
          <div className='my-3'>
            <Link
              to={getEncryptedRoute('../viewhotelbookingdetails/', { menuId: menuId })}
              state={{ bookingId: row.bookingId }}
            >
              <div className='fw-bold fs-5'>#{row.bookingCode != '' ? row.bookingCode : ''}</div>
            </Link>
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => Number(row.bookingCode),
        sortField: 'bookingCode',
        width: '150px',
      },
      {
        name: t('Action'),
        cell: (row: any) => {
          // const checkInDate = new Date(row.checkInDate);
          // const currentDate = new Date();
          // const isFutureDate = checkInDate > currentDate;

          // // If current date/time is >= checkInDate, return empty string
          // if (currentDate >= checkInDate) {
          //   return '';
          // }
          // isFutureDate &&
          return (
            <>
              {menuIdEdit ? (
                <div className='d-flex justify-content-around'>
                  {row.mainStatus == 0 ? (
                    <>
                      <button
                        className='btn btn-sm btn-icon btn-color-success btn-active-light-success me-2'
                        title='Approve Booking'
                        onClick={() => {
                          rejectconfirmation('1', row.bookingId)
                        }}
                      >
                        <KTIcon iconName='check-square' className='fs-1' />
                      </button>
                      <button
                        className='btn btn-sm btn-icon btn-color-danger btn-active-light-danger me-2'
                        title='Reject Booking'
                        onClick={() => {
                          rejectconfirmation('2', row.bookingId)
                        }}
                      >
                        <KTIcon iconName='cross-square' className='fs-1' />
                      </button>
                    </>
                  ) : (
                    ''
                  )}
                  {/* {row.mainStatus == 3 || row.mainStatus == 2 ? ( */}
                  {row.mainStatus != 1 ? (
                    ''
                  ) : (
                    <button
                      className='btn btn-sm btn-icon btn-color-warning'
                      title='Cancel Booking'
                      onClick={() => {
                        rejectconfirmation('3', row.bookingId, row.bookingdetailid)
                      }}
                    >
                      <KTIcon iconName='minus-circle' className='fs-1' />
                    </button>
                  )}
                </div>
              ) : (
                ''
              )}
            </>
          )
        },
        width: '200px',
      },
      {
        name: t('Verification Status'),
        cell: (row: any) => (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              padding: '4px 0', // Reduced padding
            }}
          >
            {row.mainStatus == 0 ? (
              <span
                className='btn btn-warning mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'
                style={{ marginTop: 0 }}
              >
                {t('Pending')}
              </span>
            ) : row.mainStatus == 1 ? (
              <span
                className='btn btn-success mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'
                style={{ marginTop: 0 }}
              >
                {t('Approved')}
              </span>
            ) : row.mainStatus == 2 ? (
              <span
                className='btn btn-light-danger mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'
                style={{ marginTop: 0 }}
              >
                {t('Rejected')}
              </span>
            ) : row.mainStatus == 3 ? (
              <>
                <span
                  className='btn btn-danger mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'
                  style={{ marginTop: 0 }}
                >
                  {t('Cancelled')}
                </span>
                <div className='text-center mt-2'>
                  {row.cancellationCharge !== '' ? (
                    <div>
                      {row.cancellationCharge !== '' ? (
                        <>
                          ( <span className='fw-bold fs-6'>{row.cancellationCharge}%</span> {t("Charges")})
                        </>
                      ) : (
                        <>
                          (<span className='fw-bold fs-6'>0%</span> {t("Charges")})
                        </>
                      )}
                    </div>
                  ) : (
                    <>
                      (<span className='fw-bold fs-6'>0%</span> {t("Charges")})
                    </>
                  )}
                </div>
              </>
            ) : (
              <span
                className='btn btn-success mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'
                style={{ marginTop: 0 }}
              >
                {t('Completed')}
              </span>
            )}
          </div>
        ),
        sortable: true,
        filter: true,
        width: '180px',
        selector: (row: any) => String(row.mainStatus),
        sortField: 'mainStatus',
      },
      {
        name: t('Payment Status'),
        cell: (row: any) => (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              padding: '4px 0', // Reduced padding
            }}
          >
            {row.paymentStatus == 'PAID' ? (
              <span className='btn btn-success mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>
                {t('Paid')}
              </span>
            ) : row.paymentStatus == 'HOLD' ? (
              <span
                className='btn text-white mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'
                style={{ backgroundColor: 'orange' }}
              >
                {t('Hold')}
              </span>
            ) : row.paymentStatus == 'REVERSED' ? (
              <span className='btn btn-light-danger mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>
                {t('Reversed')}
              </span>
            ) : row.paymentStatus == 'PENDING' ? (
              <span className='btn btn-warning mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>
                {t('Pending')}
              </span>
            ) : row.paymentStatus == 'CANCELLED' || row.paymentStatus == 'FAILED' ? (
              <>
                <span className='btn btn-danger mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>
                  {row.paymentStatus == 'CANCELLED' ? t('Cancelled') : t('Failed')}
                </span>
              </>
            ) : (
              <span className='fw-bold'>N/A</span>
            )}
            <div className='text-center mt-2'>
              <span className='fs-6'>
                {row.processDate && row.processDate !== ''
                  ? moment(row.processDate).format('DD.MM.YYYY HH:mm')
                  : '--'}
              </span>
            </div>
          </div>
        ),
        sortable: true,
        filter: true,
        width: '180px',
        selector: (row: any) => String(row.paymentStatus),
        sortField: 'paymentStatus',
      },
      {
        name: t('Accommodation Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.enroomTypeName != '' ? row.enroomTypeName : '-'}
            </div>
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => String(row.enroomTypeName),
        sortField: 'enroomTypeName',
        width: '180px',
      },
      {
        name: t('Customer Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.userName != '' ? row.userName : '-'}</div>
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => String(row.userName),
        sortField: 'userName',
        width: '170px',
      },
      {
        name: t('Guest Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.guestName != '' ? row.guestName : '-'}</div>
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => String(row.guestName),
        sortField: 'guestName',
        width: '170px',
      },
      {
        name: t('Check In'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.checkInDate != '' && row.checkInDate  ? formatDate2(row.checkInDate) : '-'}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.checkInDate),
        sortField: 'checkInDate',
        filter: true,
        width: '180px',
      },
      {
        name: t('Check Out'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.checkOutDate != '' && row.checkOutDate ? formatDate2(row.checkOutDate) : '-'}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.checkOutDate),
        sortField: 'checkOutDate',
        filter: true,
        width: '180px',
      },
      {
        name: t('Room Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.enName != '' ? row.enName : '-'}</div>
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => String(row.enName),
        sortField: 'enName',
        width: '170px',
      },
      {
        name: t('Booked On'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.created != ''  && row.created ? formatDate2(row.created) : '-'}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.created),
        sortField: 'created',
        filter: true,
        width: '170px',
      },

      {
        name: t('Original Amount'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.originalAmount != '' ? formatNumber(parseFloat(row.originalAmount)) : '0 UZS'}
            </div>
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => Number(row.originalAmount),
        sortField: 'originalAmount',
        width: '170px',
      },
      {
        name: t('Final Amount'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.totalAmount != '' ? formatNumber(parseFloat(row.totalAmount)) : '0 UZS'}
            </div>
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => Number(row.totalAmount),
        sortField: 'totalAmount',
        width: '170px',
      },
      {
        name: t('Insayr Service Fee'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.insayrFee != '' ? formatNumber(parseFloat(row.insayrFee)) : '0 UZS'}
            </div>
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => Number(row.insayrFee),
        sortField: 'insayrFee',
        width: '170px',
      },
    ],
    [t]
  )

  useEffect(() => {
    propertyListApiCall()
    hotelRoomTypeListAPIcall()
    setStatus('')
    document.title = 'Insayr | View Accommodations Bookings'
  }, [])

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-body'>
          <div className='d-flex overflow-auto'>
            <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder my-2 flex-nowrap'>
              <li className='nav-item'>
                <button
                  className={`nav-link text-active-primary me-6 p-3 text-nowrap  ${status == '' ? 'bg-success text-white rounded' : ''
                    }`}
                  onClick={() => {
                    BookingListApiCall('ALL', 1)
                    setStatus('')
                  }}
                >
                  {t('All')}
                </button>
              </li>
              <li className='nav-item'>
                <button
                  className={`nav-link text-active-primary me-6 p-3 text-nowrap ${status == '0' ? 'bg-success text-white rounded' : ''
                    }`}
                  onClick={() => {
                    BookingListApiCall('0', 0)
                    setStatus('0')
                  }}
                >
                  {t('Pending')}
                </button>
              </li>
              <li className='nav-item'>
                <button
                  className={`nav-link text-active-primary me-6 p-3 text-nowrap ${status == 1 ? 'bg-success text-white rounded' : ''
                    }`}
                  onClick={() => {
                    BookingListApiCall('1', 0)
                    setStatus('1')
                  }}
                >
                  {t('Approved')}
                </button>
              </li>
              <li className='nav-item'>
                <button
                  className={`nav-link text-active-primary me-6 p-3 text-nowrap ${status == 2 ? 'bg-success text-white rounded' : ''
                    }`}
                  onClick={() => {
                    BookingListApiCall('2', 0)
                    setStatus('2')
                  }}
                >
                  {t('Rejected')}
                </button>
              </li>
              <li className='nav-item'>
                <button
                  className={`nav-link text-active-primary me-6 p-3 text-nowrap ${status == 3 ? 'bg-success text-white rounded' : ''
                    }`}
                  onClick={() => {
                    BookingListApiCall('3', 0)
                    setStatus('3')
                  }}
                >
                  {t('Cancelled')}
                </button>
              </li>
              <li className='nav-item'>
                <button
                  className={`nav-link text-active-primary me-6 p-3 text-nowrap  ${status == 4 ? 'bg-success text-white rounded' : ''
                    }`}
                  onClick={() => {
                    BookingListApiCall('4', 0)
                    setStatus('4')
                  }}
                >
                  {t('Completed')}
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <ToastContainer />
      {isLoading && <Loader />}

      <div className='container'>
        <div className='justify-content-center d-flex flex-wrap gap-5 mb-6'>
          <div className='filters'>
            <label htmlFor='fromDate' className='fs-4 form-label'>
              {t('From Date')}
            </label>
            <input
              type='date'
              name='fromDate'
              className='form-control'
              placeholder={t('From Date')}
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>
          <div className='filters'>
            <label htmlFor='toDate' className='fs-4 form-label'>
              {t('To Date')}
            </label>
            <input
              type='date'
              name='toDate'
              className='form-control'
              placeholder={t('To Date')}
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>
          <div className='filters'>
            <label htmlFor='SelectStatus' className='fs-4 form-label'>
              {t('Select Status')}
            </label>
            <Select
              name='SelectStatus'
              id='SelectStatus'
              placeholder={t('Select Status')}
              isSearchable={true}
              options={statusList}
              value={selectedStatus}
              onChange={(e: any) => setSelectedStatus(e)}
              styles={{
                container: (provided : CSSObjectWithLabel) => ({ ...provided, width: '100%' }),
                control: (provided : CSSObjectWithLabel) => ({ ...provided, minHeight: 43 }),
              }}
            />
          </div>
          <div className='filters'>
            <label htmlFor='selectProperty' className='fs-4 form-label'>
              {t('Select Property')}
            </label>
            <Select
              name='selectProperty'
              id='selectProperty'
              placeholder={t('Select Property')}
              isSearchable={true}
              options={propertyList}
              value={selectedProperty}
              onChange={(e: any) => setSelectedProperty(e)}
              styles={{
                container: (provided : CSSObjectWithLabel) => ({ ...provided, width: '100%' }),
                control: (provided : CSSObjectWithLabel) => ({ ...provided, minHeight: 43 }),
              }}
            />
          </div>
          <div className='filters'>
            <label htmlFor='selectRoomType' className='fs-4 form-label'>
              {t('Select Room Type')}
            </label>
            <Select
              name='selectRoomType'
              id='selectRoomType'
              placeholder={t('Select Room Type')}
              isSearchable={true}
              options={roomTypeList}
              value={selectedRoomType}
              onChange={(e: any) => setSelectedRoomType(e)}
              styles={{
                container: (provided : CSSObjectWithLabel) => ({ ...provided, width: '100%' }),
                control: (provided : CSSObjectWithLabel) => ({ ...provided, minHeight: 43 }),
              }}
            />
          </div>
        </div>
      </div>

      <div className='d-flex justify-content-center mb-5'>
        <div className='col-md-2 mb-3 d-flex align-items-end'>
          <button
            className='btn btn-primary mx-1'
            onClick={() => BookingListApiCall(selectedStatus ? selectedStatus.value : status, 0)}
          >
            {t('Apply')}
          </button>
          <button className='btn btn-danger mx-1' onClick={() => clearFields()}>
            {t('Clear')}
          </button>
        </div>
      </div>
      {totalRecords > 0 || searchTerm != '' || !isDataLoaded ? (
        <>
          <DataTable
            columns={column}
            data={hotelList}
            pagination
            paginationServer={true}
            paginationTotalRows={totalRecords}
            paginationPerPage={limit}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handleRowsPerPageChange}
            sortServer={true}
            onSort={handleSort}
            subHeader={true}
            subHeaderComponent={
              <CustomHeader search={inputValue} isfoc={focus} customSearch={hotelsearch} />
            }
            customStyles={customStyles} // Apply custom styles
            paginationComponentOptions={{
              rowsPerPageText: t('Rows Per Page'),
            }}
          />
        </>
      ) : (
        <>
          <div className='text-center px-4'>
            <div className='d-flex justify-content-center align-items-center flex-column my-10'>
              <h2 className='fs-2x fw-bold mb-10'>{t('Sorry There Are No Bookings')}</h2>
            </div>

            <br />
          </div>
          <div className='d-flex justify-content-center'>
            <img
              className='mw-100 mh-300px'
              alt=''
              src={toAbsoluteUrl('/media/illustrations/sketchy-1/2.png')}
            />
          </div>
        </>
      )}
    </>
  )
}

export { ViewHotelBooking }
